


// import React, { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { FaUserCircle, FaCheckCircle, FaChartBar, FaPlusCircle, FaCalendarPlus, FaTrophy, FaArrowRight, FaMedal } from "react-icons/fa";
// import axios from 'axios';

// const Dashboard = () => {
//     const navigate = useNavigate();
//     const [events, setEvents] = useState([]);
//     const [user, setUser] = useState(null);

//     useEffect(() => {
//         const storedUser = sessionStorage.getItem('user');
//         if (storedUser) {
//             setUser(JSON.parse(storedUser));
//         }
//     }, []);

//     useEffect(() => {
//         if (user?.id) fetchEvents();
//     }, [user]);

//     const fetchEvents = async () => {
//         try {
//             const response = await axios.get(`https://rvapi.emedha.in/pages/api/api/events?userId=${user.id}`);
//             setEvents(response.data);
//         } catch (error) {
//             console.error(error);
//         }
//     };

//     const handleNavigation = (path) => navigate(path);

//     const handleLogout = () => {
//         sessionStorage.clear();
//         alert('You have been logged out!');
//         navigate('/');
//     };

//     // Main premium brand custom color tokens
//     const colors = {
//         orange: '#f35018',
//         blue: '#2f3194',
//         cyan: '#63decc',
//         glassWhite: 'rgba(255, 255, 255, 0.85)',
//         textMain: '#0f1137'
//     };

//     return (
//         <div className="d-flex flex-column min-vh-100" style={{ 
//             background: 'linear-gradient(135deg, #f4f5fc 0%, #eef0fa 100%)', 
//             fontFamily: '"Plus Jakarta Sans", "Poppins", sans-serif', 
//             color: colors.textMain,
//             position: 'relative',
//             overflowX: 'hidden'
//         }}>
            
//             {/* LUXURY BACKGROUND BLUR ORBS */}
//             <div style={{ position: 'absolute', width: '400px', height: '400px', borderRadius: '50%', background: `radial-gradient(circle, rgba(99,222,204,0.15) 0%, rgba(255,255,255,0) 70%)`, top: '-100px', right: '-100px', zIndex: 0, pointerEvents: 'none' }} />
//             <div style={{ position: 'absolute', width: '500px', height: '500px', borderRadius: '50%', background: `radial-gradient(circle, rgba(47,49,148,0.06) 0%, rgba(255,255,255,0) 70%)`, bottom: '-150px', left: '-150px', zIndex: 0, pointerEvents: 'none' }} />

//             {/* PREMIUM GLASSMORPHIC HEADER */}
//             <header className="navbar navbar-expand-lg px-4 py-3 sticky-top" style={{ 
//                 backdropFilter: 'blur(20px)', 
//                 backgroundColor: 'rgba(255, 255, 255, 0.75)', 
//                 borderBottom: '1px solid rgba(47, 49, 148, 0.06)',
//                 boxShadow: '0 4px 30px rgba(0, 0, 0, 0.02)',
//                 zIndex: 10
//             }}>
//                 <div className="container-fluid d-flex justify-content-between align-items-center">
                    
//                     {/* Brand Identity */}
//                     <div className="d-flex align-items-center">
                        
//                         <span className="fw-extrabold tracking-tight d-none d-sm-inline ms-3" style={{ fontSize: '21px', color: colors.blue, letterSpacing: '-0.5px' }}>
//                             Quizify<span style={{ color: colors.orange }}>AI</span>
//                         </span>
//                     </div>

//                     {/* Active Session Status Badge */}
//                 <div className="text-center px-3 py-2 rounded-pill d-flex align-items-center justify-content-center shadow-inner" style={{ 
//         background: 'linear-gradient(90deg, #ffffff 0%, #f4f6fc 100%)', 
//         border: '1px solid rgba(47, 49, 148, 0.08)',
//         maxWidth: '55%', 
//         minWidth: '260px' 
//     }}>
//         <div className="d-flex align-items-center text-truncate">

//             <img 
//                 src={events.find((event) => event.flag === 1)?.file || 'https://via.placeholder.com/100'} 
//                 alt="Event Logo" 
//                 className="img-fluid me-2" 
//                 style={{ 
//                     maxWidth: '24px', 
//                     maxHeight: '24px', 
//                     objectFit: 'contain', 
//                     borderRadius: '4px', 
//                     backgroundColor: '#fff',
//                     boxShadow: '0 2px 6px rgba(0,0,0,0.05)'
//                 }} 
//             />
//             <h5 className="mb-0 fw-bold text-truncate" style={{ fontSize: '13px', color: colors.blue, letterSpacing: '0.3px' }}>
//                 {events.find((event) => event.flag === 1)?.name || 'No Active Session'}
//             </h5>
//         </div>
//     </div>

//                     {/* User Controls */}
//                     <div className="d-flex align-items-center gap-3">
//                         {user && (
//                             <div className="text-end d-none d-md-block">
//                                 <small className="text-muted d-block" style={{ fontSize: '10px', uppercase: 'true', fontWeight: '700', letterSpacing: '0.5px' }}>HOST</small>
//                                 <span className="fw-bold" style={{ fontSize: '14px', color: colors.textMain }}>{user.name || 'Administrator'}</span>
//                             </div>
//                         )}
//                         <div 
//                             onClick={handleLogout}
//                             style={{ 
//                                 cursor: 'pointer', 
//                                 color: '#a0a5ba', 
//                                 transition: 'all 0.3s ease',
//                                 padding: '4px',
//                                 borderRadius: '50%'
//                             }}
//                             title="Sign Out"
//                             onMouseEnter={(e) => { e.currentTarget.style.color = colors.orange; e.currentTarget.style.transform = 'scale(1.05)'; }}
//                             onMouseLeave={(e) => { e.currentTarget.style.color = '#a0a5ba'; e.currentTarget.style.transform = 'scale(1)'; }}
//                         >
//                             <FaUserCircle size={34} />
//                         </div>
//                     </div>

//                 </div>
//             </header>

//             {/* MAIN INTERACTIVE MATRIX GRID */}
//             <main className="flex-grow-1 py-5" style={{ zIndex: 1 }}>
//                 <div className="container-xl px-4">
                    
//                     {/* Elegant Banner Section */}
//                     <div className="mb-5 text-center text-sm-start position-relative">
//                         <div style={{ display: 'inline-block', padding: '6px 14px', borderRadius: '30px', backgroundColor: 'rgba(47,49,148,0.06)', color: colors.blue, fontSize: '11px', fontWeight: '8px', letterSpacing: '1px', marginBottom: '12px', textTransform: 'uppercase' }}>
//                             Workspace Management
//                         </div>
//                         <h2 className="fw-black mb-2" style={{ color: colors.blue, fontSize: '34px', letterSpacing: '-1px', fontWeight: '800' }}>
//                             Interactive Control Suite
//                         </h2>
//                         <p className="text-muted" style={{ fontSize: '15px', maxWidth: '600px' }}>
//                             Initiate real-time engine lobbies, deploy poll modules, and view structured metric data sheets.
//                         </p>
//                     </div>

//                     {/* Luxury Layout Cards Array */}
//                     <div className="row g-4 justify-content-center">
                        
//                         {/* 1. COMPONENT: AI QUIZ ROOM */}
//                         <div className="col-12 col-sm-6 col-md-4 col-lg-3">
//                             <div 
//                                 className="card h-100 border-0 rounded-4 overflow-hidden position-relative"
//                                 onClick={() => handleNavigation('/QuestionnaireForm/253643/QuestionnaireForm')}
//                                 style={cardDesign}
//                                 onMouseEnter={(e) => triggerCardHover(e, colors.blue)}
//                                 onMouseLeave={(e) => clearCardHover(e)}
//                             >
//                                 <div className="card-body p-4 d-flex flex-column align-items-start justify-content-between">
//                                     <div className="w-100 d-flex justify-content-between align-items-center mb-4">
//                                         <div className="p-3 rounded-3" style={{ background: 'linear-gradient(135deg, rgba(47,49,148,0.08) 0%, rgba(47,49,148,0.01) 100%)', color: colors.blue }}>
//                                             <FaTrophy size={24} />
//                                         </div>
//                                         <span style={arrowIconStyle} className="arrow-icon"><FaArrowRight size={12} /></span>
//                                     </div>
//                                     <div>
//                                         <h5 className="fw-bold mb-2" style={{ fontSize: '17px', letterSpacing: '-0.3px' }}>AI Quiz</h5>
//                                         <p className="text-muted mb-0" style={{ fontSize: '12px', lineHeight: '1.5' }}>Generate quizzes instantly using AI models and share live public countdown links.</p>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>

//                         {/* 2. COMPONENT: POLL QUIZ ROOM */}
//                         {/* <div className="col-12 col-sm-6 col-md-4 col-lg-3">
//                             <div 
//                                 className="card h-100 border-0 rounded-4 overflow-hidden position-relative"
//                                 onClick={() => handleNavigation('/PollQuestionForm/45g63476tr/PollQuestionForm')}
//                                 style={cardDesign}
//                                 onMouseEnter={(e) => triggerCardHover(e, colors.orange)}
//                                 onMouseLeave={(e) => clearCardHover(e)}
//                             >
//                                 <div className="card-body p-4 d-flex flex-column align-items-start justify-content-between">
//                                     <div className="w-100 d-flex justify-content-between align-items-center mb-4">
//                                         <div className="p-3 rounded-3" style={{ background: 'linear-gradient(135deg, rgba(243,80,24,0.08) 0%, rgba(243,80,24,0.01) 100%)', color: colors.orange }}>
//                                             <FaCheckCircle size={24} />
//                                         </div>
//                                         <span style={arrowIconStyle} className="arrow-icon"><FaArrowRight size={12} /></span>
//                                     </div>
//                                     <div>
//                                         <h5 className="fw-bold mb-2" style={{ fontSize: '17px', letterSpacing: '-0.3px' }}>Poll Quiz</h5>
//                                         <p className="text-muted mb-0" style={{ fontSize: '12px', lineHeight: '1.5' }}>Create custom poll-based quiz rounds and gather live audience choice metrics.</p>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div> */}

//                         {/* 3. COMPONENT: ANALYTICS & REPORTS */}
//                         <div className="col-12 col-sm-6 col-md-4 col-lg-3">
//                             <div 
//                                 className="card h-100 border-0 rounded-4 overflow-hidden position-relative"
//                                 onClick={() => handleNavigation('/QuizResults/45g63476tr/QuizResults')}
//                                 style={cardDesign}
//                                 onMouseEnter={(e) => triggerCardHover(e, colors.cyan)}
//                                 onMouseLeave={(e) => clearCardHover(e)}
//                             >
//                                 <div className="card-body p-4 d-flex flex-column align-items-start justify-content-between">
//                                     <div className="w-100 d-flex justify-content-between align-items-center mb-4">
//                                         <div className="p-3 rounded-3" style={{ background: 'linear-gradient(135deg, rgba(99,222,204,0.15) 0%, rgba(99,222,204,0.02) 100%)', color: '#109f89' }}>
//                                             <FaChartBar size={24} />
//                                         </div>
//                                         <span style={arrowIconStyle} className="arrow-icon"><FaArrowRight size={12} /></span>
//                                     </div>
//                                     <div>
//                                         <h5 className="fw-bold mb-2" style={{ fontSize: '17px', letterSpacing: '-0.3px' }}>Analytics & Quiz Results</h5>
//                                         <p className="text-muted mb-0" style={{ fontSize: '12px', lineHeight: '1.5' }}>Analyze session leaderboard lists, score performance rows, and final data sheets.</p>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>

//                         {/* 4. COMPONENT: CONFIGURE EVENT */}
//                         <div className="col-12 col-sm-6 col-md-4 col-lg-3">
//                             <div 
//                                 className="card h-100 border-0 rounded-4 overflow-hidden position-relative"
//                                 onClick={() => handleNavigation('/createnewevent/25g4643')}
//                                 style={cardDesign}
//                                 onMouseEnter={(e) => triggerCardHover(e, colors.blue)}
//                                 onMouseLeave={(e) => clearCardHover(e)}
//                             >
//                                 <div className="card-body p-4 d-flex flex-column align-items-start justify-content-between">
//                                     <div className="w-100 d-flex justify-content-between align-items-center mb-4">
//                                         <div className="p-3 rounded-3" style={{ background: 'linear-gradient(135deg, rgba(47,49,148,0.08) 0%, rgba(47,49,148,0.01) 100%)', color: colors.blue }}>
//                                             <FaCalendarPlus size={24} />
//                                         </div>
//                                         <span style={arrowIconStyle} className="arrow-icon"><FaArrowRight size={12} /></span>
//                                     </div>
//                                     <div>
//                                         <h5 className="fw-bold mb-2" style={{ fontSize: '17px', letterSpacing: '-0.3px' }}>Configure Event</h5>
//                                         <p className="text-muted mb-0" style={{ fontSize: '12px', lineHeight: '1.5' }}>Instantiate brand new active event properties and manage global parameters.</p>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>


//                         {/* 4b. COMPONENT: CERTIFICATE BUILDER CONTROL SUITE */}
//                         <div className="col-12 col-sm-6 col-md-4 col-lg-3">
//                             <div 
//                                 className="card h-100 border-0 rounded-4 overflow-hidden position-relative"
//                                 onClick={() => handleNavigation('/certificate-designer')}
//                                 style={cardDesign}
//                                 onMouseEnter={(e) => triggerCardHover(e, colors.orange)}
//                                 onMouseLeave={(e) => clearCardHover(e)}
//                             >
//                                 <div className="card-body p-4 d-flex flex-column align-items-start justify-content-between">
//                                     <div className="w-100 d-flex justify-content-between align-items-center mb-4">
//                                         <div className="p-3 rounded-3" style={{ background: 'linear-gradient(135deg, rgba(243,80,24,0.08) 0%, rgba(243,80,24,0.01) 100%)', color: colors.orange }}>
//                                             <FaMedal size={24} />
//                                         </div>
//                                         <span style={arrowIconStyle} className="arrow-icon"><FaArrowRight size={12} /></span>
//                                     </div>
//                                     <div>
//                                         <h5 className="fw-bold mb-2" style={{ fontSize: '17px', letterSpacing: '-0.3px' }}>Certificate Designer</h5>
//                                         <p className="text-muted mb-0" style={{ fontSize: '12px', lineHeight: '1.5' }}>Customize premium credentials, upload structural logos/signatures, and select layouts.</p>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>

//                         {/* 5. COMPONENT: MANUAL CREATION BLOCK */}
//                         {/* <div className="col-12 col-sm-6 col-md-4 col-lg-3">
//                             <div 
//                                 className="card h-100 rounded-4 overflow-hidden position-relative"
//                                 onClick={() => handleNavigation('/quiz')}
//                                 style={{ 
//                                     ...cardDesign, 
//                                     border: `2px dashed rgba(47,49,148,0.15)`,
//                                     background: 'rgba(255, 255, 255, 0.4)'
//                                 }}
//                                 onMouseEnter={(e) => {
//                                     triggerCardHover(e, colors.cyan);
//                                     e.currentTarget.style.border = `2px dashed ${colors.cyan}`;
//                                 }}
//                                 onMouseLeave={(e) => {
//                                     clearCardHover(e);
//                                     e.currentTarget.style.border = `2px dashed rgba(47,49,148,0.15)`;
//                                     e.currentTarget.style.background = 'rgba(255, 255, 255, 0.4)';
//                                 }}
//                             >
//                                 <div className="card-body p-4 d-flex flex-column align-items-start justify-content-between">
//                                     <div className="w-100 d-flex justify-content-between align-items-center mb-4">
//                                         <div className="p-3 rounded-3" style={{ backgroundColor: '#ffffff', color: colors.blue, boxShadow: '0 4px 12px rgba(0,0,0,0.04)' }}>
//                                             <FaPlusCircle size={24} />
//                                         </div>
//                                         <span style={arrowIconStyle} className="arrow-icon"><FaArrowRight size={12} /></span>
//                                     </div>
//                                     <div>
//                                         <h5 className="fw-bold mb-1" style={{ fontSize: '17px', color: colors.blue, letterSpacing: '-0.3px' }}>+ Create Quiz</h5>
//                                         <p className="text-muted mb-0" style={{ fontSize: '12px', lineHeight: '1.5' }}>Craft custom questions and accurate answer vectors completely step-by-step from scratch.</p>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div> */}

//                     </div>
//                 </div>
//             </main>

//             {/* HIGH-END MINIMAL FOOTER */}
//             <footer className="border-top text-center py-4 mt-auto" style={{ 
//                 backgroundColor: 'rgba(255,255,255,0.6)', 
//                 backdropFilter: 'blur(10px)',
//                 borderColor: 'rgba(47, 49, 148, 0.05)'
//             }}>
//                 <p className="mb-0 text-muted fw-semibold" style={{ fontSize: '11px', letterSpacing: '0.5px', textTransform: 'uppercase' }}>
//                     &copy; 2026 <span style={{ color: colors.blue, fontWeight: '800' }}>Quizify<span style={{ color: colors.orange }}>ai</span></span>. All global operations structural property retained.
//                 </p>
//             </footer>
//         </div>
//     );
// };

// // Luxury Glass-Card Style Base Token
// const cardDesign = {
//     cursor: 'pointer',
//     backgroundColor: 'rgba(255, 255, 255, 0.85)',
//     backdropFilter: 'blur(20px)',
//     border: '1px solid rgba(255, 255, 255, 0.7)',
//     boxShadow: '0 10px 30px rgba(15, 17, 55, 0.03)',
//     transition: 'all 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
//     transform: 'translateY(0) scale(1)',
// };

// const arrowIconStyle = {
//     color: '#a0a5ba',
//     transition: 'all 0.3s ease',
//     opacity: 0.5
// };

// // Luxury Dynamic Hover Engine Actions
// const triggerCardHover = (e, highlightColor) => {
//     e.currentTarget.style.transform = 'translateY(-8px) scale(1.01)';
//     e.currentTarget.style.backgroundColor = '#ffffff';
//     e.currentTarget.style.boxShadow = `0 20px 38px rgba(15, 17, 55, 0.06), 0 4px 0px ${highlightColor}`;
    
//     // Animate the internal tiny icon arrow slightly to the right side
//     const arrow = e.currentTarget.querySelector('.arrow-icon');
//     if (arrow) {
//         arrow.style.color = highlightColor;
//         arrow.style.opacity = '1';
//         arrow.style.transform = 'translateX(4px)';
//     }
// };

// const clearCardHover = (e) => {
//     e.currentTarget.style.transform = 'translateY(0) scale(1)';
//     e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.85)';
//     e.currentTarget.style.boxShadow = '0 10px 30px rgba(15, 17, 55, 0.03)';
    
//     const arrow = e.currentTarget.querySelector('.arrow-icon');
//     if (arrow) {
//         arrow.style.color = '#a0a5ba';
//         arrow.style.opacity = '0.5';
//         arrow.style.transform = 'translateX(0)';
//     }
// };

// export default Dashboard;





import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaUserCircle, FaCheckCircle, FaChartBar, FaPlusCircle, FaCalendarPlus, FaTrophy, FaArrowRight, FaMedal,FaCrown, FaCheck, FaStar, FaQrcode ,FaClock, FaExclamationTriangle, FaCopy, FaPlay, FaUsers} from "react-icons/fa";
import axios from 'axios';
import QrScan from '../Images/QrScan.jpeg';


    const colors = {
        orange: '#f35018',
        blue: '#2f3194',
        cyan: '#63decc',
        glassWhite: 'rgba(255, 255, 255, 0.85)',
        textMain: '#0f1137'
    };

const Dashboard = () => {
    const navigate = useNavigate();
    const [events, setEvents] = useState([]);
    const [user, setUser] = useState(null);

    const [hostSessions, setHostSessions] = useState([]);


const [showSessionsModal, setShowSessionsModal] = useState(false);
const [copiedPin, setCopiedPin] = useState(null);

const handleCopyLink = (pin) => {
  const link = `${window.location.origin}/join?pin=${pin}`;
  navigator.clipboard.writeText(link);
  setCopiedPin(pin);
  setTimeout(() => setCopiedPin(null), 2000);
};


const fetchUserSessions = async () => {
  if (!user?.id) return;
  try {
    const res = await axios.get(`https://rvapi.emedha.in/pages/api/api/quiz/user-sessions/${user.id}`);
    if (res.data?.success) {
      setHostSessions(res.data.sessions);
    }
  } catch (err) {
    console.error("Failed to load user sessions:", err);
  }
};

useEffect(() => {
  if (user?.id) fetchUserSessions();
}, [user]);


    useEffect(() => {
        const storedUser = sessionStorage.getItem('user');
        if (storedUser) {
            setUser(JSON.parse(storedUser));
        }
    }, []);

    useEffect(() => {
        if (user?.id) fetchEvents();
    }, [user]);


    // --- Subscription Modal & Checkout States ---
    const [showPlansModal, setShowPlansModal] = useState(false);
    const [billingCycle, setBillingCycle] = useState('monthly'); // 'monthly' | 'annual'
    const [selectedPlanForPay, setSelectedPlanForPay] = useState(null); // null = browse plans, object = payment form
    const [paySubmitting, setPaySubmitting] = useState(false);
    const [paymentProofFile, setPaymentProofFile] = useState(null);
    const [payForm, setPayForm] = useState({
        name: '',
        email: '',
        mobile: '',
        transactionId: '',
        paymentDate: new Date().toISOString().split('T')[0]
    });


    // --- Live Subscription & Quota State ---
    const [subStatus, setSubStatus] = useState(null);

    const fetchSubStatus = async () => {
        if (!user?.id) return;
        try {
            const res = await axios.get(`https://rvapi.emedha.in/pages/api/api/subscription/current-status/${user.id}`);
            if (res.data?.success) {
                setSubStatus(res.data);
            }
        } catch (error) {
            console.error('Failed to fetch subscription status:', error);
        }
    };

    useEffect(() => {
        if (user?.id) fetchSubStatus();
    }, [user]);



    // Sync prefilled data from user session
    useEffect(() => {
        if (user) {
            setPayForm(prev => ({
                ...prev,
                name: user.name || '',
                email: user.email || '',
                mobile: user.mobile || ''
            }));
        }
    }, [user]);

    // Exact Pricing Specs from your Landing Page (30 days cycle, combined Event Quizzes text)
  const subscriptionPlans = [
  {
    id: 'basic',
    name: 'Basic',
    tag: 'STARTER TIER',
    desc: 'Essential tools for individual tutors and micro-classrooms.',
    monthlyPrice: 3000,
    annualPrice: 28800, // 20% discount (3000 * 12 * 0.8)
    isFeatured: false,
    perks: [
      '2 Event Quizzes per month',
      'Up to 100 users per quiz',
      '1 Basic Certificate Template',
      'Live Leaderboard & Speed Ranks',
      'In-browser participation (No app)'
    ]
  },
  {
    id: 'silver',
    name: 'Silver',
    tag: 'GROWTH TIER',
    desc: 'Tailored for training academies and mid-size institutions.',
    monthlyPrice: 5000,
    annualPrice: 48000, // 20% discount (5000 * 12 * 0.8)
    isFeatured: false,
    perks: [
      '5 Event Quizzes per month',
      'Up to 100 users per quiz',
      '2 Designer Certificate Templates',
      'Bulk WhatsApp & Email Dispatch',
      'Participant Analytics & CSV Export'
    ]
  },
  {
    id: 'gold',
    name: 'Gold',
    tag: 'MOST POPULAR',
    desc: 'Designed for colleges, institutes, and active summit hosts.',
    monthlyPrice: 7500,
    annualPrice: 72000, // 20% discount (7500 * 12 * 0.8)
    isFeatured: true,
    perks: [
      '10 Event Quizzes per month',
      'Up to 100 users per quiz',
      '3 Premium Certificate Templates',
      'Custom Host Branding & Signatures',
      'Live Podium & Precision Drop-off Logs'
    ]
  },
  {
    id: 'platinum',
    name: 'Platinum',
    tag: 'ENTERPRISE TIER',
    desc: 'Maximum scale for universities, conventions, and enterprises.',
    monthlyPrice: 10000,
    annualPrice: 96000, // 20% discount (10000 * 12 * 0.8)
    isFeatured: false,
    perks: [
      '20 Event Quizzes per month',
      'Unlimited users per quiz',
      '4 Custom Executive Templates',
      'Multi-Signer Avatars & Custom Domains',
      'High-Concurrency Priority & Full Audit Logs'
    ]
  }
];

    const handlePaymentSubmit = async (e) => {
        e.preventDefault();
        if (!paymentProofFile) {
            alert('Please upload your payment screenshot proof.');
            return;
        }

        const currentPrice = billingCycle === 'monthly' ? selectedPlanForPay.monthlyPrice : selectedPlanForPay.annualPrice;
        const formData = new FormData();
        formData.append('userId', user.id);
        formData.append('planName', selectedPlanForPay.name);
        formData.append('billingCycle', billingCycle);
        formData.append('amount', currentPrice);
        formData.append('fullName', payForm.name);
        formData.append('email', payForm.email);
        formData.append('mobile', payForm.mobile);
        formData.append('transactionId', payForm.transactionId);
        formData.append('paymentDate', payForm.paymentDate);
        formData.append('screenshot', paymentProofFile);

        setPaySubmitting(true);
        try {
            const res = await axios.post('https://rvapi.emedha.in/pages/api/api/subscription/submit-payment', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            if (res.data.success) {
                alert('Payment verification submitted! Admin will verify and activate your plan.');
                setSelectedPlanForPay(null);
                setShowPlansModal(false);
                setPaymentProofFile(null);
                setPayForm(prev => ({ ...prev, transactionId: '' }));
                fetchSubStatus()
            }

        } catch (error) {
            console.error('Payment submission failed:', error);
            alert(error.response?.data?.message || 'Failed to submit payment details. Try again.');
        } finally {
            setPaySubmitting(false);
        }
    };



    const fetchEvents = async () => {
        try {
            const response = await axios.get(`https://rvapi.emedha.in/pages/api/api/events?userId=${user.id}`);
            setEvents(response.data);
        } catch (error) {
            console.error(error);
        }
    };

    const handleNavigation = (path) => navigate(path);

    const handleLogout = () => {
        sessionStorage.clear();
        alert('You have been logged out!');
        navigate('/');
    };

    // Main premium brand custom color tokens


    return (
        <div className="d-flex flex-column min-vh-100" style={{ 
            background: 'linear-gradient(135deg, #f4f5fc 0%, #eef0fa 100%)', 
            fontFamily: '"Plus Jakarta Sans", "Poppins", sans-serif', 
            color: colors.textMain,
            position: 'relative',
            overflowX: 'hidden'
        }}>
            
            {/* LUXURY BACKGROUND BLUR ORBS */}
            <div style={{ position: 'absolute', width: '400px', height: '400px', borderRadius: '50%', background: `radial-gradient(circle, rgba(99,222,204,0.15) 0%, rgba(255,255,255,0) 70%)`, top: '-100px', right: '-100px', zIndex: 0, pointerEvents: 'none' }} />
            <div style={{ position: 'absolute', width: '500px', height: '500px', borderRadius: '50%', background: `radial-gradient(circle, rgba(47,49,148,0.06) 0%, rgba(255,255,255,0) 70%)`, bottom: '-150px', left: '-150px', zIndex: 0, pointerEvents: 'none' }} />

            {/* PREMIUM GLASSMORPHIC HEADER */}
            <header className="navbar navbar-expand-lg px-4 py-3 sticky-top" style={{ 
                backdropFilter: 'blur(20px)', 
                backgroundColor: 'rgba(255, 255, 255, 0.75)', 
                borderBottom: '1px solid rgba(47, 49, 148, 0.06)',
                boxShadow: '0 4px 30px rgba(0, 0, 0, 0.02)',
                zIndex: 10
            }}>
                <div className="container-fluid d-flex justify-content-between align-items-center">
                    
                    {/* Brand Identity */}
                    <div className="d-flex align-items-center">
                        
                        <span className="fw-extrabold tracking-tight d-none d-sm-inline ms-3" style={{ fontSize: '21px', color: colors.blue, letterSpacing: '-0.5px' }}>
                            Quizify<span style={{ color: colors.orange }}>AI</span>
                        </span>
                    </div>

                    {/* Active Session Status Badge */}
                <div className="text-center px-3 py-2 rounded-pill d-flex align-items-center justify-content-center shadow-inner" style={{ 
        background: 'linear-gradient(90deg, #ffffff 0%, #f4f6fc 100%)', 
        border: '1px solid rgba(47, 49, 148, 0.08)',
        maxWidth: '55%', 
        minWidth: '260px' 
    }}>
        <div className="d-flex align-items-center text-truncate">

            <img 
                src={events.find((event) => event.flag === 1)?.file || 'https://via.placeholder.com/100'} 
                alt="Event Logo" 
                className="img-fluid me-2" 
                style={{ 
                    maxWidth: '24px', 
                    maxHeight: '24px', 
                    objectFit: 'contain', 
                    borderRadius: '4px', 
                    backgroundColor: '#fff',
                    boxShadow: '0 2px 6px rgba(0,0,0,0.05)'
                }} 
            />
            <h5 className="mb-0 fw-bold text-truncate" style={{ fontSize: '13px', color: colors.blue, letterSpacing: '0.3px' }}>
                {events.find((event) => event.flag === 1)?.name || 'No Active Session'}
            </h5>
        </div>
    </div>

                    {/* User Controls */}
                    <div className="d-flex align-items-center gap-3">
                        {user && (
                            <div className="text-end d-none d-md-block">
                                <small className="text-muted d-block" style={{ fontSize: '10px', uppercase: 'true', fontWeight: '700', letterSpacing: '0.5px' }}>HOST</small>
                                <span className="fw-bold" style={{ fontSize: '14px', color: colors.textMain }}>{user.name || 'Administrator'}</span>
                            </div>
                        )}
                        <div 
                            onClick={handleLogout}
                            style={{ 
                                cursor: 'pointer', 
                                color: '#a0a5ba', 
                                transition: 'all 0.3s ease',
                                padding: '4px',
                                borderRadius: '50%'
                            }}
                            title="Sign Out"
                            onMouseEnter={(e) => { e.currentTarget.style.color = colors.orange; e.currentTarget.style.transform = 'scale(1.05)'; }}
                            onMouseLeave={(e) => { e.currentTarget.style.color = '#a0a5ba'; e.currentTarget.style.transform = 'scale(1)'; }}
                        >
                            <FaUserCircle size={34} />
                        </div>
                    </div>

                </div>
            </header>

            {/* MAIN INTERACTIVE MATRIX GRID */}
            <main className="flex-grow-1 py-5" style={{ zIndex: 1 }}>
                <div className="container-xl px-4">
                    
                    {/* Elegant Banner Section */}
                    <div className="mb-5 text-center text-sm-start position-relative">
                        <div style={{ display: 'inline-block', padding: '6px 14px', borderRadius: '30px', backgroundColor: 'rgba(47,49,148,0.06)', color: colors.blue, fontSize: '11px', fontWeight: '8px', letterSpacing: '1px', marginBottom: '12px', textTransform: 'uppercase' }}>
                            Workspace Management
                        </div>
                        <h2 className="fw-black mb-2" style={{ color: colors.blue, fontSize: '34px', letterSpacing: '-1px', fontWeight: '800' }}>
                            Interactive Control Suite
                        </h2>
                        <p className="text-muted" style={{ fontSize: '15px', maxWidth: '600px' }}>
                            Initiate real-time engine lobbies, deploy poll modules, and view structured metric data sheets.
                        </p>
                    </div>

                    {/* LIVE QUOTA & STATUS RIBBON */}
                    {subStatus && (
                        <div 
                            className="p-3 mb-4 rounded-4 d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3 shadow-sm"
                            style={{
                                backgroundColor: '#ffffff',
                                border: `1.5px solid ${
                                    subStatus.planStatus === 'trial_expired' || subStatus.planStatus === 'expired'
                                        ? '#fecdd3'
                                        : subStatus.type === 'paid'
                                        ? '#bbf7d0'
                                        : '#fed7aa'
                                }`,
                                background: subStatus.planStatus === 'trial_expired' || subStatus.planStatus === 'expired'
                                    ? 'linear-gradient(90deg, #fff1f2 0%, #ffffff 100%)'
                                    : subStatus.type === 'paid'
                                    ? 'linear-gradient(90deg, #f0fdf4 0%, #ffffff 100%)'
                                    : 'linear-gradient(90deg, #fff7ed 0%, #ffffff 100%)'
                            }}
                        >
                            {/* Left: Status Message & Plan Details */}
                            <div className="d-flex align-items-center gap-3">
                                <div 
                                    style={{
                                        width: '42px',
                                        height: '42px',
                                        borderRadius: '12px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        backgroundColor: subStatus.planStatus === 'trial_expired' || subStatus.planStatus === 'expired'
                                            ? 'rgba(239, 68, 68, 0.15)'
                                            : subStatus.type === 'paid'
                                            ? 'rgba(16, 185, 129, 0.15)'
                                            : 'rgba(243, 80, 24, 0.15)',
                                        color: subStatus.planStatus === 'trial_expired' || subStatus.planStatus === 'expired'
                                            ? colors.orange
                                            : subStatus.type === 'paid'
                                            ? '#10b981'
                                            : colors.orange
                                    }}
                                >
                                    {subStatus.planStatus === 'trial_expired' || subStatus.planStatus === 'expired' ? (
                                        <FaExclamationTriangle size={20} />
                                    ) : (
                                        <FaClock size={20} />
                                    )}
                                </div>

                                <div>
                                    <div className="d-flex align-items-center gap-2">
                                        <span 
                                            style={{
                                                fontSize: '11px',
                                                fontWeight: '800',
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.6px',
                                                color: subStatus.type === 'paid' ? '#047857' : colors.orange
                                            }}
                                        >
                                            {subStatus.planTier.toUpperCase()} PLAN
                                        </span>
                                        
                                        <span 
                                            className="badge rounded-pill"
                                            style={{
                                                fontSize: '10px',
                                                fontWeight: '700',
                                                backgroundColor: subStatus.planStatus === 'trial_expired' || subStatus.planStatus === 'expired'
                                                    ? '#fee2e2'
                                                    : subStatus.type === 'paid'
                                                    ? '#dcfce7'
                                                    : '#fef3c7',
                                                color: subStatus.planStatus === 'trial_expired' || subStatus.planStatus === 'expired'
                                                    ? '#b91c1c'
                                                    : subStatus.type === 'paid'
                                                    ? '#15803d'
                                                    : '#b45309'
                                            }}
                                        >
                                            {subStatus.planStatus === 'trial_active' && `${subStatus.hoursLeft}h Left in Trial`}
                                            {subStatus.planStatus === 'active' && `${subStatus.daysLeft} Days Remaining`}
                                            {(subStatus.planStatus === 'trial_expired' || subStatus.planStatus === 'expired') && 'Access Expired'}
                                        </span>
                                    </div>

                                    <div style={{ fontSize: '13px', fontWeight: '700', color: colors.textMain, marginTop: '2px' }}>
                                        Quota: {subStatus.usedQuizzes} of {subStatus.allowedQuizzes} Event Quizzes Used
                                        <span className="text-muted fw-normal ms-2">
                                            ({subStatus.quizzesRemaining} remaining &bull; Max {subStatus.maxParticipants === -1 ? 'Unlimited' : subStatus.maxParticipants} participants/quiz)
                                        </span>
                                    </div>
                                </div>
                            </div>

                            {/* Right: Upgrade / Extend CTA Button */}
                            <div>
                                <button
                                    onClick={() => {
                                        setSelectedPlanForPay(null);
                                        setShowPlansModal(true);
                                    }}
                                    className="btn btn-sm fw-bold px-3 py-2"
                                    style={{
                                        borderRadius: '10px',
                                        backgroundColor: subStatus.planStatus === 'trial_expired' || subStatus.planStatus === 'expired' ? colors.orange : colors.blue,
                                        color: '#ffffff',
                                        fontSize: '12px',
                                        boxShadow: '0 4px 12px rgba(0,0,0,0.06)'
                                    }}
                                >
                                    <FaCrown className="me-1" />
                                    {subStatus.planStatus === 'trial_expired' || subStatus.planStatus === 'expired' 
                                        ? 'Upgrade to Paid Plan' 
                                        : 'Renew or Extend Plan'}
                                </button>
                            </div>
                        </div>
                    )}

                    {/* Luxury Layout Cards Array */}
                    <div className="row g-4 justify-content-center">

                            {/* 4. COMPONENT: CONFIGURE EVENT */}
                        <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                            <div 
                                className="card h-100 border-0 rounded-4 overflow-hidden position-relative"
                                onClick={() => handleNavigation('/createnewevent/25g4643')}
                                style={cardDesign}
                                onMouseEnter={(e) => triggerCardHover(e, colors.blue)}
                                onMouseLeave={(e) => clearCardHover(e)}
                            >
                                <div className="card-body p-4 d-flex flex-column align-items-start justify-content-between">
                                    <div className="w-100 d-flex justify-content-between align-items-center mb-4">
                                        <div className="p-3 rounded-3" style={{ background: 'linear-gradient(135deg, rgba(47,49,148,0.08) 0%, rgba(47,49,148,0.01) 100%)', color: colors.blue }}>
                                            <FaCalendarPlus size={24} />
                                        </div>
                                        <span style={arrowIconStyle} className="arrow-icon"><FaArrowRight size={12} /></span>
                                    </div>
                                    <div>
                                        <h5 className="fw-bold mb-2" style={{ fontSize: '17px', letterSpacing: '-0.3px' }}>Configure Event</h5>
                                        <p className="text-muted mb-0" style={{ fontSize: '12px', lineHeight: '1.5' }}>Instantiate brand new active event properties and manage global parameters.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        {/* 1. COMPONENT: AI QUIZ ROOM */}
                        <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                            <div 
                                className="card h-100 border-0 rounded-4 overflow-hidden position-relative"
                                onClick={() => handleNavigation('/QuestionnaireForm/253643/QuestionnaireForm')}
                                style={cardDesign}
                                onMouseEnter={(e) => triggerCardHover(e, colors.blue)}
                                onMouseLeave={(e) => clearCardHover(e)}
                            >
                                <div className="card-body p-4 d-flex flex-column align-items-start justify-content-between">
                                    <div className="w-100 d-flex justify-content-between align-items-center mb-4">
                                        <div className="p-3 rounded-3" style={{ background: 'linear-gradient(135deg, rgba(47,49,148,0.08) 0%, rgba(47,49,148,0.01) 100%)', color: colors.blue }}>
                                            <FaTrophy size={24} />
                                        </div>
                                        <span style={arrowIconStyle} className="arrow-icon"><FaArrowRight size={12} /></span>
                                    </div>
                                    <div>
                                        <h5 className="fw-bold mb-2" style={{ fontSize: '17px', letterSpacing: '-0.3px' }}>AI Quiz</h5>
                                        <p className="text-muted mb-0" style={{ fontSize: '12px', lineHeight: '1.5' }}>Generate quizzes instantly using AI models and share live public countdown links.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* 2. COMPONENT: POLL QUIZ ROOM */}
                        {/* <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                            <div 
                                className="card h-100 border-0 rounded-4 overflow-hidden position-relative"
                                onClick={() => handleNavigation('/PollQuestionForm/45g63476tr/PollQuestionForm')}
                                style={cardDesign}
                                onMouseEnter={(e) => triggerCardHover(e, colors.orange)}
                                onMouseLeave={(e) => clearCardHover(e)}
                            >
                                <div className="card-body p-4 d-flex flex-column align-items-start justify-content-between">
                                    <div className="w-100 d-flex justify-content-between align-items-center mb-4">
                                        <div className="p-3 rounded-3" style={{ background: 'linear-gradient(135deg, rgba(243,80,24,0.08) 0%, rgba(243,80,24,0.01) 100%)', color: colors.orange }}>
                                            <FaCheckCircle size={24} />
                                        </div>
                                        <span style={arrowIconStyle} className="arrow-icon"><FaArrowRight size={12} /></span>
                                    </div>
                                    <div>
                                        <h5 className="fw-bold mb-2" style={{ fontSize: '17px', letterSpacing: '-0.3px' }}>Poll Quiz</h5>
                                        <p className="text-muted mb-0" style={{ fontSize: '12px', lineHeight: '1.5' }}>Create custom poll-based quiz rounds and gather live audience choice metrics.</p>
                                    </div>
                                </div>
                            </div>
                        </div> */}

                        {/* 3. COMPONENT: ANALYTICS & REPORTS */}
                        <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                            <div 
                                className="card h-100 border-0 rounded-4 overflow-hidden position-relative"
                                onClick={() => handleNavigation('/QuizResults/45g63476tr/QuizResults')}
                                style={cardDesign}
                                onMouseEnter={(e) => triggerCardHover(e, colors.cyan)}
                                onMouseLeave={(e) => clearCardHover(e)}
                            >
                                <div className="card-body p-4 d-flex flex-column align-items-start justify-content-between">
                                    <div className="w-100 d-flex justify-content-between align-items-center mb-4">
                                        <div className="p-3 rounded-3" style={{ background: 'linear-gradient(135deg, rgba(99,222,204,0.15) 0%, rgba(99,222,204,0.02) 100%)', color: '#109f89' }}>
                                            <FaChartBar size={24} />
                                        </div>
                                        <span style={arrowIconStyle} className="arrow-icon"><FaArrowRight size={12} /></span>
                                    </div>
                                    <div>
                                        <h5 className="fw-bold mb-2" style={{ fontSize: '17px', letterSpacing: '-0.3px' }}>Analytics & Quiz Results</h5>
                                        <p className="text-muted mb-0" style={{ fontSize: '12px', lineHeight: '1.5' }}>Analyze session leaderboard lists, score performance rows, and final data sheets.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    


                        {/* 4b. COMPONENT: CERTIFICATE BUILDER CONTROL SUITE */}
                        <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                            <div 
                                className="card h-100 border-0 rounded-4 overflow-hidden position-relative"
                                onClick={() => handleNavigation('/certificate-designer')}
                                style={cardDesign}
                                onMouseEnter={(e) => triggerCardHover(e, colors.orange)}
                                onMouseLeave={(e) => clearCardHover(e)}
                            >
                                <div className="card-body p-4 d-flex flex-column align-items-start justify-content-between">
                                    <div className="w-100 d-flex justify-content-between align-items-center mb-4">
                                        <div className="p-3 rounded-3" style={{ background: 'linear-gradient(135deg, rgba(243,80,24,0.08) 0%, rgba(243,80,24,0.01) 100%)', color: colors.orange }}>
                                            <FaMedal size={24} />
                                        </div>
                                        <span style={arrowIconStyle} className="arrow-icon"><FaArrowRight size={12} /></span>
                                    </div>
                                    <div>
                                        <h5 className="fw-bold mb-2" style={{ fontSize: '17px', letterSpacing: '-0.3px' }}>Certificate Designer</h5>
                                        <p className="text-muted mb-0" style={{ fontSize: '12px', lineHeight: '1.5' }}>Customize premium credentials, upload structural logos/signatures, and select layouts.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* 5. COMPONENT: SUBSCRIPTION & UPGRADE PLANS CARD */}
                        <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                            <div 
                                className="card h-100 border-0 rounded-4 overflow-hidden position-relative"
                                onClick={() => {
                                    setSelectedPlanForPay(null);
                                    setShowPlansModal(true);
                                }}
                                style={cardDesign}
                                onMouseEnter={(e) => triggerCardHover(e, '#f59e0b')}
                                onMouseLeave={(e) => clearCardHover(e)}
                            >
                                <div className="card-body p-4 d-flex flex-column align-items-start justify-content-between">
                                    <div className="w-100 d-flex justify-content-between align-items-center mb-4">
                                        <div className="p-3 rounded-3" style={{ background: 'linear-gradient(135deg, rgba(245, 158, 11, 0.12) 0%, rgba(245, 158, 11, 0.02) 100%)', color: '#d97706' }}>
                                            <FaCrown size={24} />
                                        </div>
                                        <span style={arrowIconStyle} className="arrow-icon"><FaArrowRight size={12} /></span>
                                    </div>
                                    <div>
                                        <div className="d-flex align-items-center gap-2 mb-2">
                                            <h5 className="fw-bold mb-0" style={{ fontSize: '17px', letterSpacing: '-0.3px', color: colors.textMain }}>Subscription &amp; Plans</h5>
                                            <span style={{ fontSize: '9px', fontWeight: '800', backgroundColor: '#fef3c7', color: '#b45309', padding: '2px 6px', borderRadius: '6px' }}>UPGRADE</span>
                                        </div>
                                        <p className="text-muted mb-0" style={{ fontSize: '12px', lineHeight: '1.5' }}>
                                            Review 30-day packages, unlock event quotas, and submit payment verifications.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* 6. COMPONENT: SCHEDULED & ACTIVE QUIZ ROOMS CARD */}
<div className="col-12 col-sm-6 col-md-4 col-lg-3">
  <div 
    className="card h-100 border-0 rounded-4 overflow-hidden position-relative"
    onClick={() => setShowSessionsModal(true)}
    style={cardDesign}
    onMouseEnter={(e) => triggerCardHover(e, colors.cyan)}
    onMouseLeave={(e) => clearCardHover(e)}
  >
    <div className="card-body p-4 d-flex flex-column align-items-start justify-content-between">
      <div className="w-100 d-flex justify-content-between align-items-center mb-4">
        <div 
          className="p-3 rounded-3" 
          style={{ 
            background: 'linear-gradient(135deg, rgba(99,222,204,0.18) 0%, rgba(99,222,204,0.02) 100%)', 
            color: '#0d9488' 
          }}
        >
          <FaClock size={24} />
        </div>
        <span style={arrowIconStyle} className="arrow-icon">
          <FaArrowRight size={12} />
        </span>
      </div>

      <div>
        <div className="d-flex align-items-center gap-2 mb-2">
          <h5 className="fw-bold mb-0" style={{ fontSize: '17px', letterSpacing: '-0.3px', color: colors.textMain }}>
            Quiz Arenas
          </h5>
          <span 
            style={{ 
              fontSize: '10px', 
              fontWeight: '800', 
              backgroundColor: '#ccfbf1', 
              color: '#0f766e', 
              padding: '2px 8px', 
              borderRadius: '8px' 
            }}
          >
            {hostSessions.length} ROOMS
          </span>
        </div>
        <p className="text-muted mb-0" style={{ fontSize: '12px', lineHeight: '1.5' }}>
          Inspect upcoming scheduled quiz instances, track pre-registered counts, and launch live rooms.
        </p>
      </div>
    </div>
  </div>
</div>

                        {/* 5. COMPONENT: MANUAL CREATION BLOCK */}
                        {/* <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                            <div 
                                className="card h-100 rounded-4 overflow-hidden position-relative"
                                onClick={() => handleNavigation('/quiz')}
                                style={{ 
                                    ...cardDesign, 
                                    border: `2px dashed rgba(47,49,148,0.15)`,
                                    background: 'rgba(255, 255, 255, 0.4)'
                                }}
                                onMouseEnter={(e) => {
                                    triggerCardHover(e, colors.cyan);
                                    e.currentTarget.style.border = `2px dashed ${colors.cyan}`;
                                }}
                                onMouseLeave={(e) => {
                                    clearCardHover(e);
                                    e.currentTarget.style.border = `2px dashed rgba(47,49,148,0.15)`;
                                    e.currentTarget.style.background = 'rgba(255, 255, 255, 0.4)';
                                }}
                            >
                                <div className="card-body p-4 d-flex flex-column align-items-start justify-content-between">
                                    <div className="w-100 d-flex justify-content-between align-items-center mb-4">
                                        <div className="p-3 rounded-3" style={{ backgroundColor: '#ffffff', color: colors.blue, boxShadow: '0 4px 12px rgba(0,0,0,0.04)' }}>
                                            <FaPlusCircle size={24} />
                                        </div>
                                        <span style={arrowIconStyle} className="arrow-icon"><FaArrowRight size={12} /></span>
                                    </div>
                                    <div>
                                        <h5 className="fw-bold mb-1" style={{ fontSize: '17px', color: colors.blue, letterSpacing: '-0.3px' }}>+ Create Quiz</h5>
                                        <p className="text-muted mb-0" style={{ fontSize: '12px', lineHeight: '1.5' }}>Craft custom questions and accurate answer vectors completely step-by-step from scratch.</p>
                                    </div>
                                </div>
                            </div>
                        </div> */}

                    </div>
                </div>
            </main>

            {/* HIGH-END MINIMAL FOOTER */}
            <footer className="border-top text-center py-4 mt-auto" style={{ 
                backgroundColor: 'rgba(255,255,255,0.6)', 
                backdropFilter: 'blur(10px)',
                borderColor: 'rgba(47, 49, 148, 0.05)'
            }}>
                <p className="mb-0 text-muted fw-semibold" style={{ fontSize: '11px', letterSpacing: '0.5px', textTransform: 'uppercase' }}>
                    &copy; 2026 <span style={{ color: colors.blue, fontWeight: '800' }}>Quizify<span style={{ color: colors.orange }}>ai</span></span>. All global operations structural property retained.
                </p>
            </footer>
            {/* SUBSCRIPTION & PAYMENT VERIFICATION MODAL */}
  {showPlansModal && (
    <div 
        style={{
            position: 'fixed',
            inset: 0,
            backgroundColor: 'rgba(11, 12, 38, 0.75)',
            backdropFilter: 'blur(8px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
            padding: '20px'
        }}
        onClick={() => {
            setShowPlansModal(false);
            setSelectedPlanForPay(null);
        }}
    >
        <div 
            style={{
                backgroundColor: '#ffffff',
                borderRadius: '24px',
                maxWidth: selectedPlanForPay ? '600px' : '1280px',
                width: '100%',
                maxHeight: '92vh',
                overflowY: 'auto',
                padding: '32px',
                boxShadow: '0 25px 60px rgba(0,0,0,0.3)',
                transition: 'all 0.3s ease'
            }}
            onClick={(e) => e.stopPropagation()}
        >
            {/* VIEW 1: PLANS CATALOG (4 TIERS) */}
            {!selectedPlanForPay ? (
                <div>
                    <div className="d-flex justify-content-between align-items-start mb-4">
                        <div className="text-center w-100 pe-3">
                            <span style={{ 
                                fontSize: '11px', 
                                fontWeight: '800', 
                                color: colors.orange, 
                                letterSpacing: '1px', 
                                textTransform: 'uppercase',
                                backgroundColor: 'rgba(243, 80, 24, 0.08)',
                                padding: '4px 14px',
                                borderRadius: '20px'
                            }}>
                                Pricing &amp; Quotas
                            </span>
                            <h2 className="fw-black mt-2 mb-1" style={{ color: colors.blue, fontSize: '26px', letterSpacing: '-0.5px' }}>
                                Plans Scaled to Your Audience
                            </h2>
                            <p className="text-muted mb-3" style={{ fontSize: '13px' }}>
                                Predictable subscriptions for tutors, academies, and enterprise organizers (30-day cycles).
                            </p>

                            {/* Billing Cycle Toggle */}
                            <div className="d-inline-flex p-1 rounded-pill" style={{ backgroundColor: '#f1f4fb', border: '1px solid #e2e8f0' }}>
                                <button 
                                    type="button" 
                                    onClick={() => setBillingCycle('monthly')}
                                    style={{
                                        border: 'none',
                                        padding: '6px 18px',
                                        borderRadius: '20px',
                                        fontSize: '12px',
                                        fontWeight: '700',
                                        backgroundColor: billingCycle === 'monthly' ? '#2f3194' : 'transparent',
                                        color: billingCycle === 'monthly' ? '#ffffff' : '#64748b',
                                        cursor: 'pointer',
                                        transition: 'all 0.2s'
                                    }}
                                >
                                    Monthly
                                </button>
                                <button 
                                    type="button" 
                                    onClick={() => setBillingCycle('annual')}
                                    style={{
                                        border: 'none',
                                        padding: '6px 18px',
                                        borderRadius: '20px',
                                        fontSize: '12px',
                                        fontWeight: '700',
                                        backgroundColor: billingCycle === 'annual' ? '#2f3194' : 'transparent',
                                        color: billingCycle === 'annual' ? '#ffffff' : '#64748b',
                                        cursor: 'pointer',
                                        transition: 'all 0.2s'
                                    }}
                                >
                                    Annual <span style={{ fontSize: '10px', backgroundColor: '#f59e0b', color: '#fff', padding: '2px 6px', borderRadius: '10px', marginLeft: '4px' }}>Save 20%</span>
                                </button>
                            </div>
                        </div>

                        <button 
                            onClick={() => setShowPlansModal(false)}
                            style={{ background: 'none', border: 'none', fontSize: '22px', color: '#94a3b8', cursor: 'pointer', lineHeight: 1 }}
                        >
                            ✕
                        </button>
                    </div>

                    {/* 4 Cards Responsive Grid */}
                    <div className="row g-3 align-items-stretch">
                        {subscriptionPlans.map((plan) => {
                            const price = billingCycle === 'monthly' ? plan.monthlyPrice : plan.annualPrice;
                            return (
                                <div key={plan.id} className="col-12 col-md-6 col-xl-3">
                                    <div 
                                        className="h-100 p-3 p-xl-4 rounded-4 d-flex flex-column justify-content-between position-relative"
                                        style={{
                                            backgroundColor: plan.isFeatured ? '#ffffff' : '#fafbfe',
                                            border: plan.isFeatured ? '2px solid #2f3194' : '1px solid #e2e8f0',
                                            boxShadow: plan.isFeatured ? '0 12px 30px rgba(47, 49, 148, 0.12)' : 'none',
                                            transform: plan.isFeatured ? 'scale(1.02)' : 'scale(1)'
                                        }}
                                    >
                                        {plan.isFeatured && (
                                            <div style={{
                                                position: 'absolute',
                                                top: '-12px',
                                                left: '50%',
                                                transform: 'translateX(-50%)',
                                                backgroundColor: '#f59e0b',
                                                color: '#fff',
                                                fontSize: '10px',
                                                fontWeight: '800',
                                                padding: '3px 12px',
                                                borderRadius: '12px',
                                                letterSpacing: '0.5px',
                                                whiteSpace: 'nowrap'
                                            }}>
                                                <FaStar size={10} style={{ marginRight: '4px' }} /> MOST POPULAR
                                            </div>
                                        )}

                                        <div>
                                            <div className="d-flex justify-content-between align-items-center mb-1">
                                                <span style={{ fontSize: '11px', fontWeight: '800', color: plan.isFeatured ? '#2f3194' : '#64748b' }}>
                                                    {plan.tag}
                                                </span>
                                            </div>
                                            <h3 className="fw-bold mb-1" style={{ color: colors.textMain, fontSize: '22px' }}>{plan.name}</h3>
                                            <p className="text-muted" style={{ fontSize: '11.5px', minHeight: '34px', lineHeight: '1.4' }}>{plan.desc}</p>
                                            
                                            {/* Price Display */}
                                            <div className="d-flex align-items-baseline mb-2">
                                                <span style={{ fontSize: '16px', fontWeight: '700', color: colors.textMain }}>₹</span>
                                                <span style={{ fontSize: '28px', fontWeight: '900', color: colors.textMain, marginLeft: '2px' }}>
                                                    {price.toLocaleString()}
                                                </span>
                                                <span className="text-muted ms-1" style={{ fontSize: '11px' }}>
                                                    {billingCycle === 'monthly' ? '/mo' : '/yr'}
                                                </span>
                                            </div>

                                            {/* Key Quota Badges */}
                                            <div className="d-flex flex-wrap gap-1 mb-3">
                                                <span style={{ 
                                                    fontSize: '11px', 
                                                    fontWeight: '700', 
                                                    backgroundColor: plan.id === 'platinum' ? 'rgba(168, 85, 247, 0.12)' : 'rgba(47, 49, 148, 0.08)', 
                                                    color: plan.id === 'platinum' ? '#9333ea' : '#2f3194',
                                                    padding: '2px 8px', 
                                                    borderRadius: '6px' 
                                                }}>
                                                    {plan.id === 'platinum' ? 'Unlimited Users' : '100 Users/quiz'}
                                                </span>
                                            </div>

                                            {/* Perks List */}
                                            <ul className="list-unstyled mb-3" style={{ fontSize: '12px', lineHeight: '1.9' }}>
                                                {plan.perks.map((perk, idx) => (
                                                    <li key={idx} className="d-flex align-items-start gap-2 mb-1">
                                                        <FaCheck size={12} style={{ marginTop: '5px', flexShrink: 0 }} color={plan.isFeatured ? colors.orange : '#10b981'} />
                                                        <span style={{ color: '#334155' }}>{perk}</span>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>

                                        <button 
                                            onClick={() => setSelectedPlanForPay(plan)}
                                            className="btn w-100 fw-bold py-2 mt-auto"
                                            style={{
                                                backgroundColor: plan.isFeatured ? colors.orange : 'transparent',
                                                color: plan.isFeatured ? '#ffffff' : colors.blue,
                                                border: plan.isFeatured ? 'none' : `1.5px solid ${colors.blue}`,
                                                borderRadius: '10px',
                                                fontSize: '13px'
                                            }}
                                        >
                                            Choose {plan.name}
                                        </button>
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    <div className="mt-4 p-3 rounded-3 text-center" style={{ backgroundColor: '#f8fafc', border: '1px dashed #cbd5e1' }}>
                        <small className="text-muted" style={{ fontSize: '11px' }}>
                            <strong>Note:</strong> All plans operate on 30-day billing periods. Up to 100 participants per quiz for Basic, Silver, and Gold. Platinum supports unlimited participants.
                        </small>
                    </div>
                </div>
            ) : (
                /* VIEW 2: CHECKOUT & PAYMENT VERIFICATION FORM */
                <div>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <button 
                            type="button" 
                            onClick={() => setSelectedPlanForPay(null)}
                            style={{ background: 'none', border: 'none', color: colors.blue, fontWeight: '700', fontSize: '13px', cursor: 'pointer' }}
                        >
                            &larr; Back to Plans
                        </button>
                        <button 
                            onClick={() => {
                                setShowPlansModal(false);
                                setSelectedPlanForPay(null);
                            }}
                            style={{ background: 'none', border: 'none', fontSize: '20px', color: '#94a3b8', cursor: 'pointer' }}
                        >
                            ✕
                        </button>
                    </div>

                    <h4 className="fw-bold mb-1" style={{ color: colors.blue }}>
                        Upgrade to {selectedPlanForPay.name} ({billingCycle.toUpperCase()})
                    </h4>
                    <p className="text-muted mb-3" style={{ fontSize: '12px' }}>
                        Review pricing, complete your details, and submit your payment verification.
                    </p>

                    {/* Selected Plan Summary Strip */}
                    <div className="p-3 rounded-3 mb-3 d-flex justify-content-between align-items-center" style={{ backgroundColor: '#f4f6fc', border: '1px solid #e2e8f0' }}>
                        <div>
                            <strong style={{ color: colors.textMain }}>{selectedPlanForPay.name} Plan</strong>
                            <div style={{ fontSize: '12px', color: '#64748b' }}>
                                {selectedPlanForPay.perks[0]} &bull; {selectedPlanForPay.perks[1]}
                            </div>
                        </div>
                        <div className="text-end">
                            <small className="text-muted d-block" style={{ fontSize: '10px' }}>TOTAL DUE</small>
                            <span style={{ fontSize: '22px', fontWeight: '900', color: colors.orange }}>
                                ₹{(billingCycle === 'monthly' ? selectedPlanForPay.monthlyPrice : selectedPlanForPay.annualPrice).toLocaleString()}
                            </span>
                        </div>
                    </div>

                    {/* QR Code Payment Box */}
                    <div className="text-center p-3 mb-3 rounded-3" style={{ backgroundColor: '#fafbfc', border: '1px dashed #cbd5e1' }}>
                        <div style={{ fontWeight: '800', fontSize: '11px', color: colors.blue, letterSpacing: '0.8px', marginBottom: '8px' }}>
                            <FaQrcode style={{ marginRight: '6px' }} /> Scan QR to Pay
                        </div>
                        <img 
                            src={QrScan} 
                            alt="UPI QR Code" 
                            style={{ 
                                width: '180px', 
                                height: '180px', 
                                objectFit: 'contain', 
                                borderRadius: '10px', 
                                border: '1px solid #e2e8f0',
                                backgroundColor: '#ffffff',
                                padding: '6px',
                                boxShadow: '0 4px 12px rgba(0,0,0,0.05)'
                            }} 
                        />
                        <p className="mt-2 mb-0 text-muted" style={{ fontSize: '11px' }}>
                            Scan using PhonePe, Google Pay, Paytm, or any UPI banking app.
                        </p>
                    </div>

                    {/* Form Fields */}
                    <form onSubmit={handlePaymentSubmit}>
                        <div className="mb-2">
                            <label className="form-label mb-1" style={{ fontSize: '12px', fontWeight: '700' }}>Full Name *</label>
                            <input 
                                type="text" 
                                className="form-control form-control-sm" 
                                required 
                                value={payForm.name} 
                                onChange={(e) => setPayForm({ ...payForm, name: e.target.value })} 
                            />
                        </div>

                        <div className="row g-2 mb-2">
                            <div className="col-6">
                                <label className="form-label mb-1" style={{ fontSize: '12px', fontWeight: '700' }}>Email Address *</label>
                                <input 
                                    type="email" 
                                    className="form-control form-control-sm" 
                                    required 
                                    value={payForm.email} 
                                    onChange={(e) => setPayForm({ ...payForm, email: e.target.value })} 
                                />
                            </div>
                            <div className="col-6">
                                <label className="form-label mb-1" style={{ fontSize: '12px', fontWeight: '700' }}>Mobile Number *</label>
                                <input 
                                    type="tel" 
                                    className="form-control form-control-sm" 
                                    required 
                                    value={payForm.mobile} 
                                    onChange={(e) => setPayForm({ ...payForm, mobile: e.target.value })} 
                                />
                            </div>
                        </div>

                        <div className="row g-2 mb-2">
                            <div className="col-6">
                                <label className="form-label mb-1" style={{ fontSize: '12px', fontWeight: '700' }}>Payment Transaction ID *</label>
                                <input 
                                    type="text" 
                                    className="form-control form-control-sm" 
                                    placeholder="e.g. UTR / UPI Ref ID" 
                                    required 
                                    value={payForm.transactionId} 
                                    onChange={(e) => setPayForm({ ...payForm, transactionId: e.target.value })} 
                                />
                            </div>
                            <div className="col-6">
                                <label className="form-label mb-1" style={{ fontSize: '12px', fontWeight: '700' }}>Payment Date *</label>
                                <input 
                                    type="date" 
                                    className="form-control form-control-sm" 
                                    required 
                                    value={payForm.paymentDate} 
                                    onChange={(e) => setPayForm({ ...payForm, paymentDate: e.target.value })} 
                                />
                            </div>
                        </div>

                        <div className="mb-3">
                            <label className="form-label mb-1" style={{ fontSize: '12px', fontWeight: '700' }}>Upload Payment Screenshot Proof *</label>
                            <input 
                                type="file" 
                                accept="image/*" 
                                className="form-control form-control-sm" 
                                required 
                                onChange={(e) => setPaymentProofFile(e.target.files[0])} 
                            />
                            <small className="text-muted" style={{ fontSize: '11px' }}>Accepted formats: JPG, JPEG, PNG (Max 10MB)</small>
                        </div>

                        <button 
                            type="submit" 
                            disabled={paySubmitting} 
                            className="btn w-100 fw-bold py-2 mt-2" 
                            style={{ backgroundColor: colors.orange, color: '#ffffff', borderRadius: '10px' }}
                        >
                            {paySubmitting ? 'Submitting Verification...' : 'Submit Payment Proof for Approval'}
                        </button>
                    </form>
                </div>
            )}
        </div>
    </div>
)}
{/* SESSIONS & SCHEDULES POPUP MODAL */}
{showSessionsModal && (
  <div 
    style={{
      position: 'fixed',
      inset: 0,
      backgroundColor: 'rgba(11, 12, 38, 0.75)',
      backdropFilter: 'blur(8px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      padding: '20px'
    }}
    onClick={() => setShowSessionsModal(false)}
  >
    <div 
      style={{
        backgroundColor: '#ffffff',
        borderRadius: '24px',
        maxWidth: '920px',
        width: '100%',
        maxHeight: '85vh',
        overflowY: 'auto',
        padding: '30px',
        boxShadow: '0 25px 60px rgba(0,0,0,0.3)',
        position: 'relative'
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {/* Modal Header */}
      <div className="d-flex justify-content-between align-items-center mb-4 pb-2 border-bottom">
        <div>
          <span style={{ fontSize: '11px', fontWeight: '800', color: colors.blue, letterSpacing: '0.8px', textTransform: 'uppercase' }}>
            Room Sessions Directory
          </span>
          <h4 className="fw-bold m-0" style={{ color: colors.textMain }}>
            Active &amp; Scheduled Quiz Rooms ({hostSessions.length})
          </h4>
        </div>
        <div className="d-flex align-items-center gap-2">
          <button 
            onClick={fetchUserSessions}
            className="btn btn-sm btn-outline-secondary fw-semibold"
            style={{ borderRadius: '8px', fontSize: '12px' }}
          >
            Refresh
          </button>
          <button 
            onClick={() => setShowSessionsModal(false)}
            style={{ background: 'none', border: 'none', fontSize: '22px', color: '#94a3b8', cursor: 'pointer', lineHeight: 1 }}
          >
            ✕
          </button>
        </div>
      </div>

      {/* Modal Body: Cards List */}
      {hostSessions.length === 0 ? (
        <div className="text-center py-5 text-muted">
          <div style={{ fontSize: '42px', marginBottom: '10px' }}>🎯</div>
          <h6 className="fw-bold text-dark">No Quiz Sessions Created Yet</h6>
          <p className="small mb-0">Open an event in <strong>AI Quiz</strong> and click <strong>Host Live</strong> or <strong>Schedule Quiz</strong> to generate room PINs.</p>
        </div>
      ) : (
 <div className="row g-3">
          {hostSessions.map((session) => {
            const isScheduled = session.status === 'scheduled';
            const isEnded = session.status === 'ended';
            const isAbandoned = session.status === 'abandoned';
            const isLive = session.status === 'lobby' || session.status === 'playing';

            // Distinct badge colors per status
            const badgeBg = isScheduled 
              ? '#fef3c7' 
              : isEnded 
              ? '#dcfce7' 
              : isAbandoned 
              ? '#fee2e2' 
              : '#cffafe';

            const badgeColor = isScheduled 
              ? '#b45309' 
              : isEnded 
              ? '#15803d' 
              : isAbandoned 
              ? '#b91c1c' 
              : '#0369a1';

            const badgeLabel = isScheduled 
              ? 'SCHEDULED' 
              : isEnded 
              ? 'COMPLETED' 
              : isAbandoned 
              ? 'ABANDONED' 
              : 'LIVE ARENA';

            return (
              <div key={session.id} className="col-12 col-md-6">
                <div 
                  className="p-3 rounded-4 d-flex flex-column justify-content-between h-100"
                  style={{
                    backgroundColor: '#fafbfc',
                    border: isLive ? `1.5px solid ${colors.cyan}` : '1px solid #e2e8f0',
                    boxShadow: '0 4px 12px rgba(15, 17, 55, 0.03)'
                  }}
                >
                  <div>
                    {/* Header: Status Badge & PIN */}
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <span style={{ fontSize: '10px', fontWeight: '800', backgroundColor: badgeBg, color: badgeColor, padding: '3px 8px', borderRadius: '10px' }}>
                        {badgeLabel}
                      </span>

                      <div className="d-flex align-items-center gap-2">
                        <span style={{ fontFamily: 'monospace', fontWeight: '800', fontSize: '14px', color: colors.orange }}>
                          PIN: {session.room_pin}
                        </span>
                        {/* Only allow copying links for active or scheduled sessions */}
                        {!isEnded && !isAbandoned && (
                          <button
                            type="button"
                            onClick={() => handleCopyLink(session.room_pin)}
                            style={{ background: 'none', border: 'none', color: copiedPin === session.room_pin ? '#10b981' : '#94a3b8', cursor: 'pointer', padding: 0 }}
                            title="Copy Link"
                          >
                            {copiedPin === session.room_pin ? <FaCheck size={12} /> : <FaCopy size={12} />}
                          </button>
                        )}
                      </div>
                    </div>

                    {/* Event Title */}
                    <h6 className="fw-bold text-truncate mb-2" style={{ color: colors.textMain }}>
                      {session.title || session.event_name}
                    </h6>

                    {/* Metadata Strip */}
                    <div className="d-flex justify-content-between small text-muted mb-3" style={{ fontSize: '11px' }}>
                      <span>
                        <FaClock className="me-1" />
                        {session.scheduled_at 
                          ? new Date(session.scheduled_at).toLocaleString() 
                          : 'Instant Live'}
                      </span>
                      <span className="fw-bold" style={{ color: colors.blue }}>
                        👥 {session.registered_count || 0} Joined
                      </span>
                    </div>
                  </div>

                  {/* Dynamic Action Button */}
                  <button
                    onClick={() => {
                      setShowSessionsModal(false);
                      if (isEnded || isAbandoned) {
                        // For completed or abandoned sessions, navigate to Results & Analytics
                        navigate(`/QuizResults/45g63476tr/QuizResults`, {
                          state: {
                            pin: session.room_pin,
                            eventId: session.event_id,
                            userId: user.id
                          }
                        });
                      } else {
                        // For scheduled or live sessions, launch/enter Host Room
                        navigate(`/HostLiveRoom/${session.room_pin}`, {
                          state: {
                            pin: session.room_pin,
                            eventId: session.event_id,
                            userId: user.id,
                            joinUrl: `${window.location.origin}/join?pin=${session.room_pin}&eventId=${session.event_id}`
                          }
                        });
                      }
                    }}
                    className="btn btn-sm w-100 fw-bold text-white"
                    style={{ 
                      backgroundColor: isEnded 
                        ? '#475569' 
                        : isAbandoned 
                        ? '#94a3b8' 
                        : isScheduled 
                        ? colors.orange 
                        : colors.blue, 
                      borderRadius: '10px' 
                    }}
                  >
                    {isEnded && '📊 View Final Standings'}
                    {isAbandoned && '📋 View Session Logs'}
                    {isScheduled && '⏰ Enter Scheduled Room'}
                    {isLive && 'Enter Live Arena 🎮'}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  </div>
)}

        </div>
    );
};

// Luxury Glass-Card Style Base Token
const cardDesign = {
    cursor: 'pointer',
    backgroundColor: 'rgba(255, 255, 255, 0.85)',
    backdropFilter: 'blur(20px)',
    border: '1px solid rgba(255, 255, 255, 0.7)',
    boxShadow: '0 10px 30px rgba(15, 17, 55, 0.03)',
    transition: 'all 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
    transform: 'translateY(0) scale(1)',
};

const arrowIconStyle = {
    color: '#a0a5ba',
    transition: 'all 0.3s ease',
    opacity: 0.5
};

// Luxury Dynamic Hover Engine Actions
const triggerCardHover = (e, highlightColor) => {
    e.currentTarget.style.transform = 'translateY(-8px) scale(1.01)';
    e.currentTarget.style.backgroundColor = '#ffffff';
    e.currentTarget.style.boxShadow = `0 20px 38px rgba(15, 17, 55, 0.06), 0 4px 0px ${highlightColor}`;
    
    // Animate the internal tiny icon arrow slightly to the right side
    const arrow = e.currentTarget.querySelector('.arrow-icon');
    if (arrow) {
        arrow.style.color = highlightColor;
        arrow.style.opacity = '1';
        arrow.style.transform = 'translateX(4px)';
    }
};

const clearCardHover = (e) => {
    e.currentTarget.style.transform = 'translateY(0) scale(1)';
    e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.85)';
    e.currentTarget.style.boxShadow = '0 10px 30px rgba(15, 17, 55, 0.03)';
    
    const arrow = e.currentTarget.querySelector('.arrow-icon');
    if (arrow) {
        arrow.style.color = '#a0a5ba';
        arrow.style.opacity = '0.5';
        arrow.style.transform = 'translateX(0)';
    }
};

export default Dashboard;